export class ImpactAssessmentT4DetailListModel {
    assessmentDetails: Array<ItemDetailList>;
    compAssessment: Array<ItemDetailList>;
    datesDeadlines: Array<ItemDetailList>;
    businessActions: Array<ItemDetailList>;

    constructor() {
        this.assessmentDetails = [];
        this.compAssessment = [];
        this.datesDeadlines = [];
        this.businessActions = [];
    }
}

export class ItemDetailList {
    itemTitle: string;
    createdOn: Date;

    constructor() {
        this.itemTitle = '';
        this.createdOn = new Date();
    }
}